import { render, staticRenderFns } from "./TableVerificadosCodigosIndividuales.vue?vue&type=template&id=85abb0be"
import script from "./TableVerificadosCodigosIndividuales.vue?vue&type=script&lang=js"
export * from "./TableVerificadosCodigosIndividuales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports